import { IApplicationContext } from '../../../types/application-context';
import { makeContextModule } from '../../../utils/makeContextModule';

export const { Context: ApplicationContext, useContext: useApplicationContext } = makeContextModule<
  IApplicationContext
>({
  contextName: 'ApplicationContext',
});
